export default __webpack_public_path__ + "static/media/detox.a9d53b05.png";